// extracted by mini-css-extract-plugin
export default {"background":"AnimatedBackground_background__GKe33","animate":"AnimatedBackground_animate__Juw3G","shimmer":"AnimatedBackground_shimmer__QejlB"};